/**
 * @fileoverview Preview mode type for controlling asset quality, video behavior, and container padding
 * @module screen-view/types/previewMode
 *
 * Enables consumers to optimize rendering based on context:
 * - Template palette, canvas nodes: Use 'static' for performance
 * - Edit dialogs, preview panels: Use 'edit' for quality with device padding
 * - Production runtime: Use 'live' for quality with reduced padding
 */

/**
 * Preview mode for controlling asset quality, video behavior, and container padding.
 *
 * - 'static': Performance mode - smaller images (200×200), video shows PNG thumbnail (no autoplay)
 *   Use case: Template palette, canvas nodes, theme grid
 *
 * - 'edit': Editor mode - full resolution images/videos, autoplay, device padding (42px top, 32px bottom)
 *   Use case: Edit dialogs, screen editor, preview panels
 *
 * - 'live': Production runtime mode - full resolution images/videos, autoplay, reduced padding (16px top/bottom)
 *   Use case: Web-shell runtime, mobile SDK preview
 */
export type PreviewMode = 'static' | 'live' | 'edit';

/**
 * Default preview mode - production-first.
 * Components that render ScreenView should explicitly pass the appropriate mode.
 */
export const DEFAULT_PREVIEW_MODE: PreviewMode = 'live';
